import { createFileRoute } from "@tanstack/react-router";

// The Dutch path the first invitation mails used (until 30-09-2026): on to /invitation with the token.
export const Route = createFileRoute("/uitnodiging")({
  beforeLoad: () => {
    window.location.replace(`/invitation${window.location.hash}`);
  },
  component: () => null,
});
